import { useContext, useEffect, useState } from "react";
import getServices from "../services/getServices";
import postService from "../services/postService";
import { AuthContext } from "../contexts/auth";
import toast from "react-hot-toast";

const usePermissoesState = () => {


    const [submit, setSubmit] = useState(false);
    const [openDialog, setOpenDialog] = useState(false)
    const [templateDeletar, setTemplateDeletar] = useState(false)
    const [pesquisa, setPesquisa] = useState('')

    const [usuarios, setUsuarios] = useState([]);
    const [permissoes, setPermissoes] = useState([]);
    const [permissoesDoUsuario, setPermissoesDoUsuario] = useState([]);
    
    const [openModalPermissoes, setOpenModalPermissoes] = useState(0);

    const { signOut, user } = useContext(AuthContext)    

    const _getPermissoesDoUsuario = async () => {
      let result = await getServices(`admin/permissaoatribuida/${openModalPermissoes}/`);
        if (result.type === 'success'){        

          let flatPermissoes = permissoes.flatMap(app =>
            app.children.flatMap(funcionalidade =>
              funcionalidade.children.flatMap(tela => tela.children.map(acao => {return {...acao, tela_id:tela.id, funcionalidade_id:funcionalidade.id, aplicacao_id: app.id}}))
            )
          );
          result.data.forEach(item => {
            let permissao = flatPermissoes.find(p => p.permissao_id === item.id);
            if (permissao) {
              setPermissoesDoUsuario(prev => [...prev, permissao.id, permissao.tela_id, permissao.funcionalidade_id, permissao.aplicacao_id]);
            }
          })
        }
        else if (result.data?.code === 'token_not_valid'){
          signOut()
        }   

    }

    useEffect(()=>{
      if (openModalPermissoes > 0) {
        _getPermissoesDoUsuario()
      } else {
        setPermissoesDoUsuario([])
      }
       

    }, [openModalPermissoes])


    const _getUsers = async () => {
        if (submit){
            return;
        }
        setSubmit(true)

        let result = await getServices('admin/usermanager/');
        if (result.type === 'success'){        
          setUsuarios(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }   


        let resultPermissao = await getServices('admin/permissoessistema/');
        if (result.type === 'success'){   
          let _permissoes = []     
            
          let cont = 1
          resultPermissao.data.forEach(item => {
            let indexAplicao = _permissoes.findIndex(a => a.label === `Aplicação: ${item.app_nome}`)
            let aplicacao = {id: cont, label:  `Aplicação: ${item.app_nome}` , children: [], permissao_id: item.id}
            if (indexAplicao > -1){
              aplicacao = _permissoes[indexAplicao]
            } else {
              cont += 1
            }
            let indexFuncionalidade = aplicacao.children.findIndex(t => t.label === `Funcionalidade: ${item.funcionalidade_nome}`)
            let funcionalidade = {id: cont, label: `Funcionalidade: ${item.funcionalidade_nome}`, children: [], permissao_id: item.id}
            if (indexFuncionalidade > -1){
              funcionalidade = aplicacao.children[indexFuncionalidade]
            }else {
              aplicacao.children.push(funcionalidade)
              cont += 1
            }
            let indexTela = funcionalidade.children.findIndex(t => t.label === `Tela: ${item.tela_nome}`)
            let tela = {id: cont, label: `Tela: ${item.tela_nome}`, children: [], permissao_id: item.id}
            if (indexTela > -1){
              tela = funcionalidade.children[indexTela]
            }
            else {
              funcionalidade.children.push(tela)
              cont += 1
            }
            tela.children.push({...item, id: cont, label: `Ação: ${item.acao_nome}`, permissao_id: item.id})
            cont += 1
            
            if (indexAplicao === -1){
              _permissoes.push(aplicacao)
            }
          })
          setPermissoes(_permissoes)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }   
        setSubmit(false)

    }

    const _postPermissoes = async () => {
        if (submit){
            return;
        }
        setSubmit(true)

        let _permissoesMarcadas = []
        let flatPermissoes = permissoes.flatMap(app =>
          app.children.flatMap(funcionalidade =>
            funcionalidade.children.flatMap(tela => tela.children.map(acao => acao))
          )
        );
        permissoesDoUsuario.forEach(id => {
          let permissao = flatPermissoes.find(p => p.id === id);
          if (permissao) {
            _permissoesMarcadas.push(permissao.permissao_id);
          }
        })

        let jsonPermissoesAtribuidas = {
          usuario: openModalPermissoes,
          permissoes: _permissoesMarcadas
        }

        let result = await postService('admin/permissaoatribuida/',jsonPermissoesAtribuidas);
        if (result.type === 'success'){        
            toast.success('Permissões atribuídas com sucesso');
            setOpenModalPermissoes(0)          
            _getUsers()
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }   
        else if (result.type === 'error'){
            toast.error(result.data.detail || 'Erro atribuindo permissões')
        }                
        setSubmit(false)
    }

    return {
        usuarios:{value: usuarios, set: _getUsers},
        permissoes:{value: permissoes, set: _postPermissoes},
        permissoesDoUsuario:{value: permissoesDoUsuario, set: setPermissoesDoUsuario},
        openModalPermissoes:{value: openModalPermissoes, set: setOpenModalPermissoes},

        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: ()=>{console.log('não implementado')}},
        itemDelete:{value:templateDeletar, set:setTemplateDeletar},  
        pesquisa: {value: pesquisa, set:setPesquisa},
        submit: {value: submit, set: _getUsers},
        
        

    }

}

export default usePermissoesState;